export type PublicPageLink = {
  href: string;
  label: string;
  description: string;
};

export const companyPageLinks: PublicPageLink[] = [
  {
    href: "/blog",
    label: "Blog",
    description: "Travel stories, destination ideas, and planning insights.",
  },
  {
    href: "/about-us",
    label: "About Us",
    description: "Who we are and how we deliver OTA services.",
  },
  {
    href: "/why-book-with-us",
    label: "Why Book With Us",
    description: "How we build trust with pricing, flexibility, and support.",
  },
  {
    href: "/contact-us",
    label: "Contact Us",
    description: "Reach sales, support, and escalation contacts.",
  },
  {
    href: "/faqs",
    label: "FAQs",
    description: "Common answers about booking, changes, and refunds.",
  },
];

export const legalPageLinks: PublicPageLink[] = [
  {
    href: "/terms-and-conditions",
    label: "Terms & Conditions",
    description: "Core rules that govern platform and booking usage.",
  },
  {
    href: "/privacy-policy",
    label: "Privacy Policy",
    description: "How personal data is collected, used, and protected.",
  },
  {
    href: "/cookie-policy",
    label: "Cookie Policy",
    description: "How cookies and analytics technologies are applied.",
  },
  {
    href: "/cancellation-refund-policy",
    label: "Cancellation & Refund Policy",
    description: "Refund timelines, supplier rules, and service fees.",
  },
  {
    href: "/booking-policy",
    label: "Booking Policy",
    description: "Booking accuracy, fare conditions, and traveler duties.",
  },
  {
    href: "/travel-disclaimer",
    label: "Travel Disclaimer",
    description: "Supplier liability, disruptions, and travel advisories.",
  },
];

export const supportPolicyMenuLinks: PublicPageLink[] = [
  ...companyPageLinks,
  ...legalPageLinks,
];

export const footerBottomLinks: Array<Pick<PublicPageLink, "href" | "label">> =
  [
    { href: "/privacy-policy", label: "Privacy Policy" },
    { href: "/faqs", label: "FAQs" },
    { href: "/contact-us", label: "Support" },
  ];
